/**
 * localStorage-backed persistence for the "Getting Started" dashboard panel.
 * Keyed per user id so a shared browser doesn't leak dismissal between accounts.
 */

const DISMISSED_KEY = "tradeLoop.gettingStarted.dismissed";
const EXPANDED_KEY = "tradeLoop.gettingStarted.expanded";

const scoped = (base: string, userId: string | undefined) =>
  userId ? `${base}.${userId}` : base;

const readBool = (key: string, fallback: boolean): boolean => {
  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return fallback;
    return raw === "1";
  } catch {
    return fallback;
  }
};

const writeBool = (key: string, value: boolean): void => {
  try {
    window.localStorage.setItem(key, value ? "1" : "0");
  } catch {
    // Storage might be full, disabled, or in private mode — silently ignore.
    // Losing the flag just means the panel appears again next session.
  }
};

export const getDismissed = (userId: string | undefined): boolean =>
  readBool(scoped(DISMISSED_KEY, userId), false);

export const setDismissed = (userId: string | undefined, value: boolean): void => {
  writeBool(scoped(DISMISSED_KEY, userId), value);
};

export const getExpanded = (userId: string | undefined): boolean =>
  readBool(scoped(EXPANDED_KEY, userId), true);

export const setExpanded = (userId: string | undefined, value: boolean): void => {
  writeBool(scoped(EXPANDED_KEY, userId), value);
};
